export enum IDPWMethod {
  TWO_KEYS = 'two-keys',
  THREE_KEYS = 'three-keys'
}
